import type { Insight } from '../types';

export const insightExists = (id: number, insights: Insight[] = []) =>
  insights.some((i) => i.id === id);
